export default "__VITE_ASSET__Cad$CCUw__"